import { FaqButtonContent, FaqStyledButton } from '../faq/faq-styles'

export type FaqTypeButtonProps = {
  altText?: string
  buttonIcon?: JSX.Element
  buttonText: string
  onClick?: () => void | JSX.Element
  selected: boolean
}

const FaqTypeButton = ({
  altText,
  buttonIcon,
  buttonText,
  onClick,
  selected
}: FaqTypeButtonProps) => (
  <FaqStyledButton title={`${altText || buttonText} button`} onClick={onClick} disabled={selected}>
    <FaqButtonContent>
      {buttonIcon}
      {buttonText}
    </FaqButtonContent>
  </FaqStyledButton>
)

export default FaqTypeButton
